import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import profileimg from "../../../assets/images/profileimg.png";
import editicon from "../../../assets/images/EDIT.png";
import pdficon from "../../../assets/images/pdficon.svg";
import excelicon from "../../../assets/images/excelicon.svg";
import gallery from "../../../assets/images/gallery.svg";
import arrowicon from "../../../assets/images/arrowicon.svg";
import ProgressBar from "react-bootstrap/ProgressBar";
import "./Profileinformationtab.css";
import { useAuth } from "../../../firebase/AuthProvider";
import Loader from "../loader/Loader";
import {
  GetSharedWithMeFilesAsync,
  GetEmployeeProfileDetailsAsync,
  getUpcomingTimeOffs,
  UpdateContactAndTimezoneAsync,
} from "../../../services/EmployeeService/EmployeeService";
import {
  EmployeeTimeOffResponseDto,
  GetEmployeeProfileDto,
  SharedFileDto,
  UpdateContactAndTimezoneRequest,
} from "../../../interfaces/Employee/Employee";
import { toast } from "react-toastify";
import { TABLENAMES } from "../../../Data/SD";
import { uploadAvatar } from "../../../services/fileServices/FileService";
import avtar from "../../../assets/images/defaultavtarimg.svg";
import FrameProfile from "../../../assets/images/FrameProfile.png";
import CLOCKWAR from "../../../assets/images/CLOCKWAR.svg";
import moment from "moment";
import { positionRanks } from "../../../utilities/PostitionRanks";
import { formatPhoneNumber } from "../../../utilities/stringUtils";
import AvatarImage from "../../ui/Avatar/AvatarImage";
import { useAvatarCache } from "../../../contexts/AvatarContext"; // Add this import
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Spinner } from "react-bootstrap";
import { FiChevronRight } from "react-icons/fi";
import { FileText, FileImage, FileSpreadsheet } from "lucide-react";


const Profileinformationtab = () => {
  const { currentUser, currentOrganization } = useAuth();
  const navigat = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<GetEmployeeProfileDto>();
  const [filesData, setFilesData] = useState<SharedFileDto[]>([]);
  const [authToken, setAuthToken] = useState<string>("");
  const { refreshAvatar } = useAvatarCache(); // Get the refreshAvatar function
  const [timeZoneUpdating, setTimezoneUpdating] = useState<boolean>(false);

  const Right = FiChevronRight as any;

  useEffect(() => {
    currentUser?.getIdToken().then((token) => {
      setAuthToken(token);
      GetUserProfileDetails(currentUser.uid, token);
    });
  }, []);

  useEffect(() => {
    if (currentUser && authToken) {
      GetEmployeeFile(authToken, currentUser.uid, 1, 5); // Show only 5 files in profile widget
    }
  }, [currentUser, authToken]);

  const timeZones = [
    { label: "Asia/Kolkata (IST)", value: "Asia/Kolkata" },
    { label: "America/Chicago (CST)", value: "America/Chicago" },
    { label: "America/New_York (EST)", value: "America/New_York" },
    { label: "America/Los_Angeles (PST)", value: "America/Los_Angeles" },
    { label: "Europe/London (GMT)", value: "Europe/London" },
    { label: "Asia/Dubai (GST)", value: "Asia/Dubai" },
    { label: "Asia/Singapore (SGT)", value: "Asia/Singapore" },
    { label: "Australia/Sydney (AEST)", value: "Australia/Sydney" },
  ];
  const GetUserProfileDetails = async (userId: string, token: string) => {
    setLoading(true);
    try {
      const res = await GetEmployeeProfileDetailsAsync(token, userId);
      if (res.success) {
        setUserDetails(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (err: any) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const [timeOffData, setTimeOffData] = useState<EmployeeTimeOffResponseDto[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [pendingTimeOffCount, setPendingTimeOffCount] = useState<number | 0>(0);

  useEffect(() => {
    const fetchTimeOffs = async () => {
      if (currentUser) {
        try {
          const authToken = await currentUser.getIdToken();
          const userId = currentUser.uid;
          const result = await getUpcomingTimeOffs(userId, authToken);

          if (result.success) {
            setTimeOffData(result.data);
            setPendingTimeOffCount(result.data[0]?.pendingTimeOffCount || 0);
          } else {
            setError(result.message);
          }
        } catch (error: any) {
          setError(error?.message || "Error to fetch the Timeoff Data");
        }
      }
    };

    fetchTimeOffs();
  }, [currentUser]);
  const firstTimeOff = timeOffData?.[0];
  const GetEmployeeFile = async (
    token: string,
    userId: string,
    pageNumber: number,
    pageSize: number
  ) => {
    // setLoading(true);
    GetSharedWithMeFilesAsync(
      token,
      userId,
      pageNumber,
      pageSize,
      "", // search term - empty for profile widget
      "uploadedOn", // sort by uploaded date
      "desc" // newest first
    )
      .then((res: any) => {
        if (res.success) {
          setFilesData(res.data.sharedFileDto);
        } else {
          toast.error(res.message || "Failed to fetch employee files.");
        }
      })
      .catch((err: any) =>
        toast.error(
          err.message || "An error occurred while fetching employee files."
        )
      );
  };

  function getFileIcon(fileName: string): React.ReactElement {
    const ext = fileName.split(".").pop()?.toLowerCase() || "unknown";
    switch (ext) {
      case "pdf":
        return <FileText className="w-[25px] h-[25px] text-red-500" />;
      case "xlsx":
      case "xls":
        return <FileSpreadsheet className="w-[25px] h-[25px] text-green-500" />;
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return <FileImage className="w-[25px] h-[25px] text-blue-500" />;
      default:
        return <FileText className="w-[25px] h-[25px] text-gray-500" />;
    }
  }

  const NaviagateToViewFile = async (fileData: SharedFileDto) => {
    if (fileData.fileType == "casefile") {
      navigat(`/casefile/file/${fileData.fileId}`);
    } else {
      navigat(`/view/user/file/${fileData.fileId}`);
    }
  };
  const formatDate = (dateStr: string) =>
    new Date(dateStr).toLocaleDateString();
  const [avatarRefreshKey, setAvatarRefreshKey] = useState<number>(0);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!currentUser?.uid) return;
    const file = event.target.files?.[0];
    if (!file) return;
    setLoading(true);
    uploadAvatar(authToken, currentUser?.uid, file)
      .then((url) => {
        if (url) {
          refreshAvatar(currentUser.uid); // <-- Invalidate cache!
          GetUserProfileDetails(currentUser.uid, authToken);
          setAvatarRefreshKey((prev) => prev + 1); // Refresh AvatarImage
        }
      })
      .catch((err) => {
        console.error("Error uploading avatar:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClickUpdateTimeZone = async () => {
    const token = await currentUser?.getIdToken();
    if (!token || !currentUser) return;

    const payload: UpdateContactAndTimezoneRequest = {
      phoneNumber: null,
      preferredTimeZone: userDetails?.timezone ? userDetails.timezone : null
    }

    try {
      setTimezoneUpdating(true);
      const res = await UpdateContactAndTimezoneAsync(token, currentUser?.uid, payload)
      if (res.success) {
        toast.success("Updated Successfully");
      } else {
        toast.error(res.message);
      }
    } catch (error: any) {
      toast.error(error.message || "Error to update");
    } finally { setTimezoneUpdating(false) }

  }

  const InfoRow = ({ label, value, border }: { label: any; value: any; border?: boolean; }) => (
    <div className={`space-y-1 pb-2 ${border ? "border-b border-[#0000000D]" : ""}`}>
      <p className="text-[#6E6E73] m-0 mb-2 text-base">{label}</p>
      <p className="text-base text-[#1D1D1F] m-0">{value}</p>
    </div>
  );

  const formatDateProfile = (dateStr?: string) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  // const GetDownlodablefileByfileLocation = (
  //   fileLocation: string,
  //   token: string
  // ): string | null => {
  //   GetDownlodablefileByfileLocationAsync(fileLocation, token)
  //     .then((url) => {
  //       if (url) {
  //         return url;
  //       } else {
  //         return null;
  //       }
  //     })
  //     .catch((err) => {
  //       return null;
  //     });
  //   }
  const safeFormat = (date: any) =>
    date === "0001-01-01T00:00:00" ? "N/A" : formatDate(date);

  const truncateFileName = (fileName: string, maxLength: number = 25) => {
    if (fileName.length <= maxLength) return fileName;

    const ext = fileName.split('.').pop();
    const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
    const truncatedName = nameWithoutExt.substring(0, maxLength - 3 - (ext?.length || 0));

    return `${truncatedName}...${ext ? '.' + ext : ''}`;
  };
  return (
    <>
      {loading && <Loader />}
      {/* <div className="common_content_inner mby_t_24">
        <div className="top border_tittle">
          <div className="top_bar_tittle">
            <h2>Profile Information</h2>
          </div>
        </div>
        <div className="profile_info_flx mby_30">
          <div className="profile_info_upload">
            <label htmlFor="upload">
              <div className="user_upload" style={{ cursor: "pointer" }}>
              
                <AvatarImage size="md" userId={currentUser?.uid || ""} key={avatarRefreshKey} />
              </div>
              <div className="edit_img">
                <img src={editicon} alt="edit icon" />
              </div>
            </label>
            <input
              type="file"
              id="upload"
              className="d-none"
              accept="image/*"
              onChange={handleFileChange}
            />
          </div>
          <div className="profile_info_grid">
            <div className="stats">
              <h3>Full Name</h3>
              <p>
                {userDetails?.firstName} {userDetails?.lastName}
              </p>
            </div>
        
            <div className="stats">
              <h3>Email</h3>
              <p
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
              >
                {userDetails?.email}
              </p>
            </div>
            <div className="stats">
              <h3>Phone Number</h3>
              <p>{formatPhoneNumber(userDetails?.phoneNumber || "")}</p>
            </div>
            <div className="stats">
              <h3>Time Zone</h3>
              <div className="timezone-input-group">
                <select
                  value={userDetails?.timezone || ""}
                  onChange={(e) =>
                    setUserDetails((prev) =>
                      prev ? { ...prev, timezone: e.target.value } : prev
                    )
                  }
                  className="form-select"
                >
                  <option value="">Select Time Zone</option>
                  {timeZones.map((tz) => (
                    <option key={tz.value} value={tz.value}>
                      {tz.label}
                    </option>
                  ))}
                </select>
                <button className="btn btn-primary btn-sm timezone-btn" type="button" onClick={handleClickUpdateTimeZone}>
                  {timeZoneUpdating ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faCheck} />}
                </button>
              </div>
            </div>

           
          </div>
        </div>

        <div className="about_designation_flx mby_30">
          <div className="top border_tittle">
            <div className="top_bar_tittle">
              <h2>About Designation</h2>
            </div>
          </div>
          <div className="about_designation_grid mby_24">
            <div className="stats">
              <h3>Start Date</h3>
              <p>{moment(userDetails?.joinDate).format("MMM D, YYYY")}</p>
            </div>
            <div className="stats">
              <h3>Position</h3>
              <div>
                {userDetails && userDetails.positions.length > 0 && (
                  <span>
                    {userDetails.positions.reduce((prev: string, current: string) =>
                      positionRanks[prev] > positionRanks[current]
                        ? prev
                        : current
                    )}
                  </span>
                )}
              </div>
            </div>
            <div className="stats report_stats_flx_stats">
              <h3>Reports to</h3>
              <ul className="report_stats_flx">
                {userDetails?.reporters.map((item, index) => (
                  <li key={index}>
                    <div className="report_stats_img_content">
                      <div className="report_stats_img">
                        <img
                          src={item?.avatar || profileimg}
                          alt="profileimg"
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = avtar;
                          }}
                        />
                      </div>
                      <div className="report_stats_img_content_txt">
                        <p>{item.name}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="about_designation_grid">
            <div className="stats">
              <h3>Waiver Type</h3>
              <p>{userDetails?.waiverType || "-"}</p>
            </div>
            <div className="stats">
              <h3>Office Location</h3>
              <div>
                {userDetails?.regions.map((item, index) => (
                  <span key={item.regionId}>
                    {item.name}
                    {index < userDetails.regions.length - 1 && ", "}
                  </span>
                ))}
              </div>
            </div>
            <div className="stats">
              <h3>Agency Name</h3>
              <p>{currentOrganization?.name}</p>
            </div>
          </div>
        </div>

        <div className="profile_info_bottom_grid">
          <div className="common_card seconday_card">
            <div className="top border_tittle">
              <div className="top_bar_tittle">
                <h2>Time Off Balances</h2>
              </div>
            </div>
            <div className="time_progress">
              <div className="progress_bar_card">
                <div className="progress_bar_tittle">
                  <span className="complete_count">
                    {firstTimeOff?.remainingLeaveCount < 0 ? (
                      // Show exceeded message
                      <>You have exceeded your leave by {Math.abs(firstTimeOff?.remainingLeaveCount)} Days</>
                    ) : (
                      // Normal available message
                      <>
                        {firstTimeOff?.remainingLeaveCount ?? 0} Days available from{" "}
                        {firstTimeOff?.allocatedLeaveCount ?? 0} Days
                      </>
                    )}
                  </span>
                </div>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={firstTimeOff?.usedLeavePercentage ?? 0}
                      label={`${firstTimeOff?.usedLeavePercentage ?? 0}%`}
                    />
                  </ProgressBar>
                </div>
              </div>

            </div>

          </div>


          <div className="common_card seconday_card">
            <div className="top border_tittle">
              <div className="top_bar_tittle">
                <h2>Upcoming Time Off</h2>
              </div>
            </div>
            <div className="upcoming_time_cntnt">
              <ul className="upcomming_time_list">
                {timeOffData.map((leave) => {
                  const startDate = leave.timeOffStartDate ? formatDate(leave.timeOffStartDate) : null;
                  const endDate = leave.timeOffEndDate ? formatDate(leave.timeOffEndDate) : null;

                  let displayText = leave.typeOfLeave;
                  if (startDate && endDate) {
                    displayText =
                      startDate === endDate
                        ? `${startDate} (${leave.typeOfLeave})`
                        : `${startDate} – ${endDate} (${leave.typeOfLeave})`;
                  } else if (startDate) {
                    displayText = `${startDate} (${leave.typeOfLeave})`;
                  }

                  return (
                    <li key={leave.id}>

                      {displayText}
                    </li>
                  );
                })}
              </ul>

              {pendingTimeOffCount > 0 && (
                <span className="yellow_seconday_badge">
                  You have {pendingTimeOffCount} pending request
                  {pendingTimeOffCount > 1 ? "s" : ""} awaiting approval.
                </span>
              )}
            </div>
          </div>


          <div className="common_card seconday_card">
            <div className="top border_tittle top_bar_flx">
              <div className="top_bar_tittle">
                <h2>Employee Files</h2>
              </div>
              <div className="view_all">
                <Link to="/employeefiles" className="arrow_link">
                  View All <img src={arrowicon} alt="arrowicon" />
                </Link>
              </div>
            </div>
            <div className="files_view_list">
              <ul>
                {filesData.map((item) => (
                  <li
                    key={item.fileId}
                    onClick={() => NaviagateToViewFile(item)}
                    className="cursor-pointer"
                  >
                    <div className="attchment_file">
                      <div className="attchment_file_icon">
                        {getFileIcon(item.fileName)}
                      </div>
                      <div className="attchment_file_txt">
                        <p title={item.fileName}>{truncateFileName(item.fileName)}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div> */}

      <div className="space-y-6 w-full">
        <div className="bg-white border rounded-xl p-6">
          <h3 className="text-xl lg:text-2xl pb-2 text-[#1D1D1F]">About Me</h3>

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 text-sm">
            <InfoRow label="A fun fact about me" border value="I have a pretty cool throat scar 🔪" />
            <InfoRow label="I am passionate about" border value="Writing, Art, Animals, Cinema (my Letterboxd account 😉)" />
            <InfoRow label="I speak" border value="English and German fluent (studied French and Spanish)" />
            <InfoRow label="Do you have a pet?" border value="Yes a dog" />

            <InfoRow label="I listen to" value="hip-hop, R&B, soul, indie pop, alt pop, folk pop, folk indie, classic rock, rap, dance… not country or Schlager 😊" />
            <InfoRow label="My favorite function in the app" value="The People function" />
          </div>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          <div className="bg-white border rounded-xl p-6">
            <h3 className="text-xl lg:text-2xl pb-2 text-[#1D1D1F]">Time Off Balances</h3>

            <div className="time_progress">
              {/* Vacation */}
              <div className="progress_bar_card">
                <div className="progress_bar_tittle">
                  <span className="complete_count">
                    {firstTimeOff?.remainingLeaveCount < 0 ? (
                      // Show exceeded message
                      <>You have exceeded your leave by {Math.abs(firstTimeOff?.remainingLeaveCount)} Days</>
                    ) : (
                      // Normal available message
                      <>
                        {firstTimeOff?.remainingLeaveCount ?? 0} Days available from{" "}
                        {firstTimeOff?.allocatedLeaveCount ?? 0} Days
                      </>
                    )}
                  </span>
                </div>
                <div className="flex justify-between flex-wrap mb-1.5">
                  <p className="text-black text-sm m-0">Usage</p>
                  <p className="text-black text-sm m-0">{firstTimeOff?.usedLeavePercentage ?? 0}%</p>
                </div>
                <div className="progress_bar_flx">
                  <ProgressBar>
                    <ProgressBar
                      variant="success"
                      now={firstTimeOff?.usedLeavePercentage ?? 0}
                      label={`${firstTimeOff?.usedLeavePercentage ?? 0}%`}
                    />
                  </ProgressBar>
                </div>
              </div>

            </div>

            <p className="text-lg text-[#1D1D1F] leading-[18px] my-4">
              Upcoming Time Off
            </p>
            <div className="upcoming_time_cntnt !text-sm">
              <ul className="space-y-4 ps-0">
                {timeOffData.length > 0 ? (
                  timeOffData.map((leave) => {
                    const startDate = leave.timeOffStartDate ? formatDate(leave.timeOffStartDate) : null;
                    const endDate = leave.timeOffEndDate ? formatDate(leave.timeOffEndDate) : null;

                    let displayDate = startDate;
                    if (startDate && endDate && startDate !== endDate) {
                      displayDate = `${startDate} – ${endDate}`;
                    }

                    return (
                      <li key={leave.id} className="flex items-start gap-2">

                        {/* Blue dot */}
                        <span className="mt-1 w-2 h-2 rounded-full bg-[#007AFF]"></span>

                        <div>
                          {/* Date */}
                          <p className="text-[14px] text-[#1D1D1F] leading-[18px] m-0">
                            {displayDate}
                          </p>

                          {/* Leave type */}
                          <p className="text-[14px] text-[#6E6E73] leading-[18px] m-0 mt-1">
                            {leave.typeOfLeave}
                          </p>
                        </div>

                      </li>
                    );
                  })
                ) : (
                  <p className="text-center text-[#8E8E93] text-[14px] font-poppins py-2">
                    No upcoming time off.
                  </p>
                )}
              </ul>



              {pendingTimeOffCount > 0 && (
                <div className="flex items-center !text-sm gap-2 bg-[#FFF9E6] rounded-[10px] px-3 py-3 leading-[20px] font-poppins text-[#1D1D1F]">

                  {/* Icon */}
                  {/* <span className="text-[#F5A623]">⏱️</span> */}
                  <img
                    src={CLOCKWAR}
                    alt="file icon"
                    className="w-[16px] h-[16px] object-contain"
                  />

                  {/* Message */}
                  <span>
                    You have{" "}
                    <span className="text-[#F5A623]">
                      {pendingTimeOffCount} pending request
                      {pendingTimeOffCount > 1 ? "s" : ""}
                    </span>{" "}
                    awaiting approval.
                  </span>

                </div>
              )}

            </div>
          </div>
          <div className="bg-white border rounded-xl p-6">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xl lg:text-2xl text-[#1D1D1F]">Employee Files</h3>
              <div className="view_all flex items-center">
                <Link to="/drive/employee-files" className="arrow_link">
                  View All <Right />
                </Link>
              </div>
            </div>

            <div className="space-y-3">
              <ul className="ps-0">
                {filesData.length > 0 ? (
                  filesData.map((item) => (
                    <li
                      key={item.fileId}
                      onClick={() => NaviagateToViewFile(item)}
                      className="cursor-pointer"
                    >
                      <div className="flex items-center gap-[14px] bg-[#F5F5F7] px-[16px] py-[18px] rounded-[12px] mb-[14px] w-full">

                        <div className="flex-shrink-0">
                          {getFileIcon(item.fileName)}
                        </div>

                        <div className="flex-1 min-w-0">
                          <p className="m-0 font-poppins font-normal text-sm tracking-[0px] text-[#1D1D1F] truncate" title={item.fileName}>
                            {truncateFileName(item.fileName)}
                          </p>
                        </div>

                      </div>
                    </li>
                  ))
                ) : (
                  <p className="text-center text-[#8E8E93] font-poppins text-[16px] py-4">
                    No files uploaded yet.
                  </p>
                )}
              </ul>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profileinformationtab;
